import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/books-download-limited.svg'


const _hoisted_1 = { class: "book-export__info" }
const _hoisted_2 = { class: "book-export__info" }

import { onBeforeMount, onBeforeUnmount, ref } from 'vue'

import { secondsToTextDate } from '@/helpers/time'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocExportLimit',
  props: {
    seconds: {},
    maxLimit: {}
  },
  setup(__props: any) {

const props = __props

const textTime = ref('')
const recallTimer = ref(true)
const secondsLeft = ref(0)

onBeforeMount(() => {
  secondsLeft.value = props.seconds
  updateTextTime()
})

/**
 * Reformat seconds to a "days, hours, minutes, seconds" string.
 * Recalls itself if secondsLeft more or equal to 0
 */
function updateTextTime(): void {
  if (secondsLeft.value <= 0) {
    // Reload the page to display the download link.
    setTimeout(() => {
      window.location.reload()
    }, 500)
    return
  }
  // Reformat seconds to a string.
  textTime.value = secondsToTextDate(secondsLeft.value)
  // Update secondsLeft (1 second less)
  secondsLeft.value--
  // If secondsLeft is more or equal to 0, call function 1 more time with 1 second timeout
  if (recallTimer.value && secondsLeft.value >= 0) {
    setTimeout(() => {
      updateTextTime()
    }, 1000)
    return
  }
  return
}

onBeforeUnmount(() => {
  // Stop timer when component is closed
  secondsLeft.value = 0
  recallTimer.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, " Full subscribers get " + _toDisplayString(__props.maxLimit) + " new downloads every 7 days. ", 1),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "book-export__additional-info" }, [
      _createTextVNode(" You currently have "),
      _createElementVNode("strong", null, "0 downloads "),
      _createTextVNode(" remaining. ")
    ], -1)),
    _createElementVNode("p", _hoisted_2, [
      _cache[0] || (_cache[0] = _createTextVNode(" New downloads will be available in ", -1)),
      _createElementVNode("strong", null, _toDisplayString(textTime.value), 1),
      _cache[1] || (_cache[1] = _createTextVNode(". ", -1))
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      class: "book-export__download-image",
      alt: "Download limit reached",
      src: _imports_0
    }, null, -1))
  ]))
}
}

})